import { defaultFont } from "./material-kit-react.js"
import tooltip from "./tooltipsStyle.js";
import { colors } from '../components/Theme/WebTheme';

/**
 * Modern header links styles with smooth animations and best practices
 */
const headerLinksModernStyle = theme => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit",
    display: "flex",
    alignItems: "center",
    gap: "4px"
  },
  listItem: {
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: "rgba(0,0,0,0.08)"
      }
    }
  },
  listItemText: {
    padding: "0 !important"
  },
  navLink: {
    color: "inherit",
    position: "relative",
    padding: "0.75rem 1rem",
    fontWeight: "500",
    fontSize: "14px",
    textTransform: "none",
    borderRadius: "8px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    alignItems: "center",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      color: "inherit",
      background: "var(--nav-hover-bg, rgba(255, 255, 255, 0.1))",
      transform: "translateY(-1px)",
      boxShadow: "none"
    },
    "&:focus": {
      color: "inherit",
      background: "var(--nav-hover-bg, rgba(255, 255, 255, 0.15))"
    },
    "&:focus-visible": {
      outline: `2px solid ${colors.PRIMARY}`,
      outlineOffset: 2,
      borderRadius: 8
    },
    "&:active": {
      transform: "translateY(0px)",
      transition: "all 0.1s cubic-bezier(0.4, 0, 0.2, 1)"
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "4px",
      marginTop: "4px",
      textAlign: "left",
      padding: "1rem 1.25rem",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "var(--nav-active-bg, rgba(255, 255, 255, 0.15))",
    borderRadius: 8,
    fontWeight: "600",
    "&:hover": {
      backgroundColor: "var(--nav-active-bg, rgba(255, 255, 255, 0.2))",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "60%",
      height: "2px",
      backgroundColor: "var(--nav-underline, currentColor)",
      borderRadius: "2px 2px 0 0"
    },
    [theme.breakpoints.down("md")]: {
      "&::before": {
        display: "none"
      }
    }
  },
  icons: {
    width: "20px",
    height: "20px",
    marginRight: "6px"
  },
  socialIcons: {
    position: "relative",
    fontSize: "18px !important",
    marginRight: "6px",
    transition: "transform 0.2s ease"
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "12px 20px",
      transition: "background-color 0.2s ease"
    }
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px"
  },
  // Menu item styles
  menuPaper: {
    borderRadius: "12px !important",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1) !important",
    marginTop: "8px !important"
  },
  menuItem: {
    padding: "12px 20px !important",
    fontSize: "14px !important",
    transition: "all 0.2s ease !important",
    "&:hover": {
      backgroundColor: "var(--nav-menu-hover, rgba(3, 59, 245, 0.08)) !important",
      paddingLeft: "24px !important"
    }
  }
});

export default headerLinksModernStyle;
